import React from "react";
import { SendShopifyFormData } from "../../Services/partnerService.js";
import { Form, SmartFormField, SubmitButton } from "../ui/Form";
import { shopifySchema } from "../../schemas/shopifySchema";
import { useTranslation } from "react-i18next";

const FormSection = React.forwardRef((props, ref) => {
  const { t } = useTranslation();

  const handleSubmit = async (data, { setFormError, setFormData }) => {
    try {
      const response = await SendShopifyFormData(data);

      if (response.status === 200) {
        // Reset form fields
        setFormData({
          companyEmail: "",
          companyUrl: "",
        });

        alert(t("shopify.shopifySuccessMsg"));
      } else {
        throw new Error(t("common.submitFailed"));
      }
    } catch (error) {
      setFormError(t("common.submitFailed"));
      throw error;
    }
  };

  return (
    <section className="w-full py-12 md:py-24 lg:py-32 bg-red-400 rounded-t-[20px] ">
      <div className="container mx-auto px-4 md:px-6 flex flex-col lg:flex-row gap-8">
        {/* Left Side: Title and Description */}
        <div className="lg:w-1/2">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-grey-500">
            {t("shopify.shopifyFormTitle")}
          </h2>
          <p className="text-lg text-grey-500 mt-4">
            {t("shopify.shopifyFormDesc")}
          </p>
        </div>

        {/* Right Side: Form */}
        <div
          ref={ref}
          className="bg-white rounded-lg shadow-md p-6 space-y-6 max-w-xl w-full"
        >
          <Form
            schema={shopifySchema}
            onSubmit={handleSubmit}
            defaultValues={{ companyEmail: "", companyUrl: "" }}
            className="space-y-4"
          >
            <SmartFormField
              name="companyEmail"
              label={t("forms.companyEmail")}
              type="email"
              required
              inputProps={{
                placeholder: "example@company.com",
                variant: "box",
              }}
            />

            <SmartFormField
              name="companyUrl"
              label={t("shopify.shopifyUrl")}
              type="url"
              required
              inputProps={{
                placeholder: "https://www.company.com",
                variant: "box",
              }}
            />

            <SubmitButton
              fullWidth
              variant="danger"
            >
              {t("career.joinWaitlist")}
            </SubmitButton>
          </Form>
        </div>
      </div>
    </section>
  );
});

export default FormSection;
